import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UiProgramType } from '../../../../enum/ui-utils.enum';
import { FileDownloadService } from '../../../../services/file-download.service';
import { ProgramDetailsModel } from '../../../../models/webinar-course.model';

@Component({
    selector: 'app-program-button',
    templateUrl: './program-button.component.html',
    styleUrl: './program-button.component.scss',
})
export class ProgramButtonComponent implements OnInit {
    @Input() details:any;
    @Input() certificateId = 0;
    @Input() completedAt = '';
    @Input() customButtonCss = '';
    @Input() isEnrol = false;
    @Input() isProgramExpired = false;
    @Input() isProgramJoinable = false;
    @Input() isLearningInProgress = false;
    @Input() isLearningCompleted = false;
    @Input() programId = '';
    @Input() programRoute = '';
    @Input() uiProgramType!: UiProgramType;
    @Input() willIncludeRecording = false;
    @Input() isMeetingEnded = false;
    @Input() isDetailsPage = false;
    @Input() isLiveTodaySection = false;
    @Output() buttonClick = new EventEmitter();

    buttonUi: ButtonUi = {} as ButtonUi;

    constructor(private fileDownloadService: FileDownloadService) {}

    ngOnInit(): void {
        this.initButtonUi();
    }

    protected onClick(): void {
        if(this.certificateId){
            this.fileDownloadService.downloadFileFromApi(this.certificateId);
        }

        this.buttonClick.emit();
    }

    private initButtonUi(): void {
        if (this.setCertificateButton()) return;
        if (this.setCompletedButton()) return;
        if (this.uiProgramType === UiProgramType.LiveWebinar && this.setLiveWebinarButton()) return;
        if (
            (this.uiProgramType === UiProgramType.Course || this.uiProgramType === UiProgramType.RecordedWebinar || this.uiProgramType === UiProgramType.Podcast) &&
            this.setCourseButton()
        )
            return;
    }

    private setCertificateButton(): boolean {
        if (!!this.completedAt && this.certificateId) {
            this.buttonUi = { text: 'button.downloadCertificate', icon: 'download-file', isDownloadButton: true };
            return true;
        }
        return false;
    }

    private setCompletedButton(): boolean {
        if (!!this.completedAt && !this.certificateId) {
            this.buttonUi = { text: 'button.completed', icon: 'play' };
            return true;
        }
        return false;
    }

    private setLiveWebinarButton(): boolean {
        let now = new Date();
        
        let isRehersal = this.isMeetingEnded && !this.completedAt && now <= new Date(this.details.startDate);

        if (!this.isEnrol && !this.isProgramExpired) {
            this.buttonUi = { text: 'button.registerNow', icon: 'fire' };
            return true;
        }

        if ((this.isProgramExpired || this.isMeetingEnded) && !isRehersal) {
            if (this.isEnrol && !this.completedAt && !this.willIncludeRecording) {
                this.buttonUi = {
                    text: 'button.didNotAttend',
                    icon: 'calendar-invalid',
                    buttonCss: this.isLiveTodaySection ? 'btn-live-today-card-disabled' : 'btn-program-card-disabled',
                };
                return true;
            }

            if (this.willIncludeRecording) {
                this.buttonUi = {
                    text: 'button.recordingAvailableSoon',
                    icon: 'calendar-invalid',
                    buttonCss: this.isLiveTodaySection ? 'btn-live-today-card-disabled' : 'btn-program-card-disabled',
                };
            } else {
                this.buttonUi = {
                    text: 'button.webinarHasEnded',
                    icon: 'calendar-invalid',
                    buttonCss: this.isLiveTodaySection ? 'btn-live-today-card-disabled' : 'btn-program-card-disabled',
                };
            }
            return true;
        }
        
        this.buttonUi = {
            text: this.isProgramJoinable ? 'button.joinNow' : 'button.registered',
            icon: this.isProgramJoinable ? 'video-camera' : 'fire',
            buttonCss: '',
        };
        return true;
    }

    private setCourseButton(): boolean {
        if (!this.isEnrol) {
            this.buttonUi = { text: 'button.enrolNow', icon: 'enrol' };
            return true;
        }

        if (this.isLearningInProgress) {
            this.buttonUi = { text: 'button.resumeLearning', icon: 'book' };
        } else {
            this.buttonUi = { text: 'button.watchNow', icon: 'play' };
        }
        return true;
    }

    private getJoinButtonCss(): string {
        if (this.isProgramJoinable && !this.isMeetingEnded) return '';
        if (this.isLiveTodaySection) return 'btn-live-today-card-disabled';
        return 'btn-program-card-disabled';
    }
}

interface ButtonUi {
    icon: string;
    text: string;
    buttonCss?: string;
    isDownloadButton?: boolean;
}
